import { computed, ref } from "vue";

export function useFlyingStars() {
  const _tl = [0, 4, 9, 2, 7, 6, 1, 8, 3, 5];
  const _tll = [0, 1, 8, 3, 4, 9, 2, 7, 6, 5];
  const _mc = [
    0, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6, 7, 7, 7, 8, 8, 8, 1,
  ];

  const starsYear = ref<number[]>([]);
  const starsMonth = ref<number[]>([]);
  const starsK = ref<number[]>([]);
  const starsFront = ref<number[]>([]);
  const starsBase = ref<number[]>([]);
  const azimuthFacade = ref<number>(0);

  const mount = computed(() => {
    if (azimuthFacade.value === 0) {
      return 1;
    }
    return angle2mount(azimuthFacade.value);
  });
  const flyingStars = computed(() => {
    const stars = [];
    for (let i = 1; i < 10; i++) {
      const tlId = _tl[i];
      stars[i] = {
        sk: starsK.value[tlId],
        sf: starsFront.value[tlId],
        sb: starsBase.value[tlId],
        sy: starsYear.value[i],
        sm: starsMonth.value[i],
      };
    }

    return stars;
  });

  function fillYearStar(year: number) {
    const cfs = 9 - ((year - 1892) % 9);
    const stars = generateStars(cfs, 1);
    for (let i = 1; i < 10; i++) {
      starsYear.value[i] = stars[_tl[i]];
    }
  }

  function fillMonthStar(year: number, month: number) {
    const yearBranch = ((year - 1876) % 12) + 1;
    const k1 = yearBranch % 3;
    let k2 = 8;
    if (k1 > 1) k2 = 5;
    if (k1 < 1) k2 = 2;
    let k3 = k2 - month + 1;
    if (k3 < 1) k3 += 9;
    if (k3 < 1) k3 += 9;
    const stars = [];
    for (let i = 1; i < 10; i++) {
      let idx = 5 + i - 1;
      if (idx > 9) idx -= 9;
      if (k3 > 9) k3 -= 9;
      stars[idx] = k3;
      k3++;
    }
    for (let i = 1; i < 10; i++) {
      starsMonth.value[i] = stars[_tl[i]];
    }
  }

  function fillBuildYearStars(year: number) {
    const period = year2period(year);
    fillFsBase(period);
    buildMountStars();
  }

  function buildMountStars() {
    fillFsFront(mount.value);
    fillFsBack(mount.value);
  }

  function fillFsBase(period: number) {
    starsBase.value = generateStars(period, 1);
  }

  function fillFsFront(mount: number) {
    const frontPal = _tll[mount2palace(mount)];
    const cfs = starsBase.value[frontPal];
    let k = star2sign(cfs) * mount2sign(mount);
    if (cfs == 5) k = star2sign(starsBase.value[5]) * mount2sign(mount);
    starsFront.value = generateStars(cfs, k, true);
  }

  function fillFsBack(mount: number) {
    let mountBack = mount - 12;
    if (mountBack < 1) mountBack += 24;
    const backPal = _tll[mount2palace(mountBack)];
    const cfs = starsBase.value[backPal];
    let k = star2sign(cfs) * mount2sign(mountBack);
    if (cfs == 5) k = star2sign(starsBase.value[5]) * mount2sign(mountBack);

    starsK.value = generateStars(cfs, k, true);
  }

  function generateStars(cfs: number, k: number, checkZero = false) {
    const stars = [];
    let localCFS = cfs;
    for (let i = 1; i < 10; i++) {
      let idx = 5 + i - 1;
      if (idx > 9) idx -= 9;
      if (localCFS > 9) localCFS -= 9;
      if (localCFS < 1 && checkZero) localCFS += 9;
      stars[idx] = localCFS;
      localCFS += k;
    }

    return stars;
  }

  function year2period(year: number) {
    let res = Math.floor((year - 1844) / 20);
    if (res > 9) res -= 9;
    return res;
  }

  function mount2palace(mount: number) {
    if (mount < 1 || mount > 24) return -1;

    return _mc[mount];
  }

  function mount2sign(mount: number) {
    return mount % 3 < 1 ? 1 : -1;
  }

  function star2sign(star: number) {
    return star % 2 > 0 ? 1 : -1;
  }

  function angle2mount(angle: number) {
    let res = Math.floor((angle + 22.5) / 15);
    if (res > 24) res -= 24;
    return res;
  }

  return {
    fillYearStar,
    fillMonthStar,
    fillBuildYearStars,
    buildMountStars,
    azimuthFacade,
    flyingStars,
  };
}
